import React from 'react'
import { observer } from 'mobx-react-lite'
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom'
import clsx from 'clsx'

import { Header } from './Header'
import { Footer } from './Footer'
import { SideBarNavigation } from './SideBarNavigation'

import { AccountScreen } from './AccountScreen'
import { PrintRoute } from './Print/PrintRoute'
import { SyncLogsScreen } from './SyncLogsScreen'
import { ImportRoute } from './Import/ImportRoute'
import { OrdersRoute } from './Orders/OrdersRoute'
import { AdminUsersScreen } from './AdminUsersScreen'
import { AdminMsAppLifecycleScreen } from './AdminMsAppLifecycleScreen'
import { SettingsRoute } from './Settings/SettingsRoute'
import { ProductsRoute } from './Products/ProductsRoute'
import { ProductDiffsScreen } from './ProductDiffsScreen'
import { MoySkladAccountRoute } from './Settings/MoySklad/MoySkladAccountRoute'

import { useStore } from '../hooks/storeHook'

import { appRoutes } from '../common/appRoutes'

export const AppRouter =
  observer(() => {
    const {hasMoySkladApp} = useStore()

    // NOTE: Can't use route hooks here
    // NOTE: react-router v6 is not worth upgrading to - lots of changes, not seeing benefits
    // NOTE: Tracking a route match here and storing in mobx doesn't work - it's still outdated

    return (
      <div className={clsx('App', {'ms-app': hasMoySkladApp})}>
        <BrowserRouter>
          <div className="app_container">
            <Header/>

            <div className="main_content">
              <SideBarNavigation/>

              {/* NOTE: All routes must be inside a switch, because it renders exclusively - https://v5.reactrouter.com/web/api/Switch */}
              <Switch>
                <Route path={appRoutes.MoySklad.account}>
                  <MoySkladAccountRoute/>
                </Route>

                <Route path={appRoutes.Diffs}>
                  <ProductDiffsScreen/>
                </Route>

                <Route path={appRoutes.Account}>
                  <AccountScreen/>
                </Route>

                <Route path={appRoutes.AdminUsers}>
                  <AdminUsersScreen/>
                </Route>

                <Route path={appRoutes.AdminMsAppLifecycle}>
                  <AdminMsAppLifecycleScreen/>
                </Route>

                <Route path={appRoutes.MoySkladApp.template}>
                  <Redirect to={appRoutes.MoySklad.account}/>
                </Route>

                {/* Backwards compatibility */}
                <Route path={appRoutes.MoySkladAppOld}>
                  <Redirect to={appRoutes.MoySklad.account}/>
                </Route>

                {/* Store route matches MS, should remain below others */}
                <Route path={appRoutes.Store.print.template}>
                  <PrintRoute/>
                </Route>

                <Route path={appRoutes.Store.settings.template}>
                  <SettingsRoute/>
                </Route>

                <Route path={appRoutes.Store.products.template}>
                  <ProductsRoute/>
                </Route>

                <Route path={appRoutes.Store.orders.template}>
                  <OrdersRoute/>
                </Route>

                <Route path={appRoutes.Store.import.template}>
                  <ImportRoute/>
                </Route>

                <Route path={appRoutes.Store.syncLogs.template}>
                  <SyncLogsScreen/>
                </Route>

                {/* NOTE: Fallback route, must remain the last one */}
                <Route path="*">
                  <Redirect to={appRoutes.MoySklad.account}/>
                </Route>
              </Switch>
            </div>

            <Footer/>
          </div>
        </BrowserRouter>
      </div>
    )
  })